export default({
  gutterBottom: {
      marginBottom: '1em'
  }
});
